import { type IItems } from "./IItems";

/*
 * A list of items that is just an array of ids (and has no direct connection to the backend and database.)
 */
export class StaticItems<S> implements IItems<S> {
	readonly items: S[];
	readonly isResetting = 0;

	constructor(items: S[]) {
		this.items = items;
	}

	async load(): Promise<void> {
		// A static list of items does not load its content from anywhere but knows
		// about it at construction time.
	}

	get totalCountEstimate(): number {
		return this.items.length;
	}

	async reset(): Promise<void> {
		// A static list does not need to explictly signal a reset to any other
		// component. If the underlying array changes, the Vue machinery is going
		// to do the correct updates automatically.
	}
}
